module.exports = __webpack_public_path__ + "img/layout-builder.59791bca.svg";